/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertShiftTemplate} from '../api'

export const useMutationUpsertShiftTemplate = createReactQueryMutationHook('upsertShiftTemplate', upsertShiftTemplate)
